export default __webpack_public_path__ + "static/media/b9695ed9d332464a63c0c08bc59fb4241598740029687.1fbefda2.webp";